export default "__VITE_ASSET__BGcwxAJm__"